module.exports = __webpack_public_path__ + "images/Snapchat-a52a13.png";